import type { Timeframe } from "@trader/shared/MarketData"

const DAY = 86_400

/**
 * How much history one request covers, per timeframe: enough bars to fill a
 * screen a few times over (roughly 1,000 to 2,500 bars on NSE). Scrolling left
 * loads one more window of the same size.
 */
export const HISTORY_WINDOW_SECONDS: Readonly<Record<Timeframe, number>> = {
  "1m": 5 * DAY,
  "3m": 10 * DAY,
  "5m": 20 * DAY,
  "15m": 60 * DAY,
  "1h": 180 * DAY,
  "4h": 365 * DAY,
  "1D": 5 * 365 * DAY
}

/** How often the newest bars are re-requested while a chart is open. */
export const TAIL_REFRESH_MS = 30_000

/**
 * Deep backtest: how far back a strategy runs, per timeframe (about 100k bars
 * at most on NSE, which the backtest worker runs in a second or two).
 */
export const DEEP_HISTORY_SECONDS: Readonly<Record<Timeframe, number>> = {
  "1m": 365 * DAY,
  "3m": 2 * 365 * DAY,
  "5m": 3 * 365 * DAY,
  "15m": 5 * 365 * DAY,
  "1h": 10 * 365 * DAY,
  "4h": 20 * 365 * DAY,
  "1D": 50 * 365 * DAY
}
